import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

const newMovies = movies.filter((m) => m.isNew);

const allMovies = movies.filter((m) => !m.isNew && !m.featured).slice(0, 4);
const displayMovies = [...newMovies, ...allMovies].slice(0, 8);

export default function NewReleasesSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900">最新上线</h2>
          <span className="bg-secondary-100 text-secondary-700 text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap">
            每周更新
          </span>
        </div>
        <Link
          to="/category/dianying"
          className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap transition-colors"
        >
          查看全部
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {displayMovies.map((movie) => (
          <MovieCard
            key={movie.id}
            id={movie.id}
            title={movie.title}
            year={movie.year}
            rating={movie.rating}
            genre={movie.genre}
            posterUrl={movie.posterUrl}
            isNew={movie.isNew}
          />
        ))}
      </div>
    </section>
  );
}